import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'palette/Button';
import { BodyText } from 'palette/Typography';
import { applyCurrentFilters, removeFiltersByType } from '@common/Filters/actions/filtersActions';
import { filterSelectors } from '@common/Filters/selectors';
import { useTranslation } from '@common/Hooks/useTranslation';
import { GA_FILTER_CLEAR_ACTION, GA_FILTER_CLEAR_ALL_LABEL, GA_FILTERS_CATEGORY } from '@common/Tracking';
import { BEMBlock } from '@helpers/classnames';
import { pushGAEventToDataLayer } from '@helpers/dataLayer';

import './FilterToplabel.scss';

export function FilterTopLabel({ filterType, label, description }) {
    const [block, BEMElement] = BEMBlock('filter-top-label');

    const dispatch = useDispatch();
    const translate = useTranslation();
    const activeFilters = useSelector(filterSelectors.activeFilters);

    const currentTypeActiveFilters = activeFilters.filter(filter => filter.filterType === filterType);
    const clearButtonMessage = currentTypeActiveFilters.length
        ? `${translate('clear')} (${currentTypeActiveFilters.length})`
        : null;

    const clearFilter = () => {
        pushGAEventToDataLayer(GA_FILTERS_CATEGORY, GA_FILTER_CLEAR_ACTION, GA_FILTER_CLEAR_ALL_LABEL);
        dispatch(removeFiltersByType(filterType));
        dispatch(applyCurrentFilters());
    };

    return (
        <div className={block}>
            <div className={BEMElement('inner-container')}>
                <div className={BEMElement('label')}>
                    <BodyText
                        className="mb-0"
                        color="strong"
                        level="1"
                        weight="bold"
                    >
                        {label}
                    </BodyText>
                </div>
                {
                    !!clearButtonMessage && (
                        <Button
                            isTransparent
                            className={BEMElement('clear-button')}
                            size="small"
                            theme="secondary"
                            onClick={clearFilter}
                        >

                            <BodyText
                                color="attention"
                                level="1"
                                lineHeight="normal"
                            >
                                {clearButtonMessage}
                            </BodyText>
                        </Button>
                    )
                }
            </div>
            { description && <p className={BEMElement('description')}>{description}</p> }
        </div>
    );
}
